import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { useWatch } from 'react-hook-form';
import { useCallback, useState } from 'react';

import { FormSection } from 'common/components/FormSection';
import { ScoringField, TextField } from 'common/forms/Field';
import { TControllerProps } from 'common/types';
import { ExpiryScaleSelectField } from 'certificate/forms/Field';
import { TCertificateFormValues } from 'certificate/types';

export const SettingsSection = ({
    control,
}: TControllerProps<TCertificateFormValues>) => {
    const [translate] = useTranslation();
    const [hasExpanded, setHasExpanded] = useState(false);

    const expiry = useWatch<TCertificateFormValues, 'expiry'>({
        control,
        name: 'expiry',
    });

    return (
        <FormSection
            renderExpanded
            description={
                <Box>{translate('certificateForm.settingsDescription')}</Box>
            }
            sx={{ borderBottom: 0 }}
            title={translate('certificateForm.settingsTitle')}
            onExpand={useCallback(() => {
                // Set expanded state once
                if (hasExpanded) return;

                setHasExpanded(true);
            }, [hasExpanded])}
        >
            <Grid container spacing={2}>
                <Grid size={4}>
                    <TextField
                        control={control}
                        label={translate('certificateForm.expiry')}
                        name="expiry"
                    />
                </Grid>

                <Grid size={8}>
                    <ExpiryScaleSelectField
                        control={control}
                        expiry={expiry || undefined}
                        name="expiryScale"
                    />
                </Grid>
            </Grid>

            <ScoringField control={control} name="scoring" />
        </FormSection>
    );
};
